import { isRequiredRule } from 'utils/eightByEightCatalog';

/**
 * Resolves the effective status of an item, applying MUST inheritance rules:
 * - If an item's rule is 'Must', its status mirrors its direct parent.
 * - Sub-child inherits from its direct parent only (not grandparent directly).
 */
export const resolveEffectiveStatus = (item, statusMap, itemsById) => {
    if (isRequiredRule(item) && item.parentId) {
        const parent = itemsById[item.parentId];
        if (parent) {
            return resolveEffectiveStatus(parent, statusMap, itemsById);
        }
    }
    return statusMap[item.id] || 'Enabled';
};
